{
    "Accessibility menu": "Barrierefreiheits-Menü",
    "Close": "Schließen",
    "Content adjustments": "Inhaltsanpassungen",
    "Navigation adjustments": "Navigationsanpassungen",
    "Text Align": "Text Align",
    "Align Left": "Links ausrichten",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Schriftgröße anpassen",
    "Highlight Title": "Titel hervorheben",
    "Highlight Links": "Links hervorheben",
    "Readable Font": "Lesbare Schriftart",
    "Colour adjustments": "Farbanpassungen",
    "Dark Contrast": "Dunkler Kontrast",
    "Light Contrast": "Heller Kontrast",
    "High Contrast": "Hoher Kontrast",
    "High Saturation": "Hohe Sättigung",
    "Low Saturation": "Niedrige Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Werkzeuge",
    "Reading Guide": "Leseführung",
    "Big Cursor": "Großer Cursor",
    "Increase Font Size": "Schriftgröße vergrößern",
    "Decrease Font Size": "Schriftgröße verkleinern",
    "Letter Spacing": "Buchstabenabstand",
    "Line Height": "Zeilenhöhe",
    "Font Weight": "Schriftschnitt",
    "Dyslexia Font": "Legasthenie-Schriftart",
    "Language": "Sprache",
    "Accessibility widget": "Barrierefreiheits-Menü öffnen",
    "Accessibility Profiles": "Barrierefreiheits-Profile",
    "Cognitive Disability": "Kognitive Beeinträchtigung",
    "Seizure Safe": "Anfallssicher",
    "Accessibility statement": "Barrierefreiheits-Erklärung",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Animationen stoppen",
    "Reset all settings": "Einstellungen Zurücksetzen",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
